import { Component, OnInit, ViewChild } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { AppTableComponent, Form, FormElement, RequestsService, TranslationManager, ViewState, Auth, MessagesComponent, RequestOpnConsentModel, RequestOpnConsentListModel, DocumentsService } from 'src/common';
import { DocumentViewModel } from 'src/views/components';

@Component({
	selector: 'usage-conditions-review',
	templateUrl: 'usage-conditions-review.component.html'
})

export class UsageConditionsReviewComponent implements OnInit {
	auth = Auth;
	requestId: number;
	viewState = ViewState;
	showDisapprovalModal: boolean = false;
	translationManager = TranslationManager;

	items: RequestOpnConsentListModel[];
	userCanVote: boolean = true;
	userAlreadyVoted: boolean = false;
	doc: DocumentViewModel;
  documentId :number=0;
  // supplierUserId: number;

	constructor(
    private router: Router,
    private service: DocumentsService)
    {}

	ngOnInit(): void {
    this.supplierUserConditionsDocumentId();
    // this.supplierUserId = Auth?.user['supplierUserId'];
	}


	private initForm(): void {
	}

  private supplierUserConditionsDocumentId(): void {
    this.service.supplierUserConditionsDocumentId().then((documentId:number) => {
      this.documentId = documentId;
      let model = new DocumentViewModel();
      model.documentId = this.documentId;
      this.doc = model;
    });
	}

	setConsentStatus(isGivenConsent: boolean) {
      Auth.saveUsageConditions(this.documentId).then(() => {
        Auth.getAuthenticatedUser();
        MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Подаци су успешно сачувани')]);
        setTimeout(() => {
          this.router.navigate(['/']);
        }, 2000)
      }).catch((reason: any) => {
        MessagesComponent.instance.showError([reason.error.messages]);
      });
	}

  disapprove() {
    this.router.navigate(['/login']);
  }

	openDisapprovalModal() {
		this.showDisapprovalModal = true;
	}

	closeDisapprovalModal() {
		this.showDisapprovalModal = false;
	}
}
